module.exports = __webpack_public_path__ + "static/media/welcome-header.97d3b01a.png";